import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield this.doPrint}}\n")